import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { colors } from '../../../../../constants'

const CloseButton = styled.button`
    background: ${colors.white};
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content:end;
    color: ${colors.greylight};
    outline: none;
    cursor: pointer;
    z-index: 3;
    border: none;
    padding-bottom:0;
    margin-left:0.5rem
`

const MediaFormGroup = styled.div`
    padding: 15px 30px 15px;
`

const FlexBox = styled.div`
    display:flex;
    width:100%;
    align-items: center;
    justify-content:space-between;
    padding-bottom:0.7rem
`
const ContainerBox = styled.div`
    width:100%
`
const MediaLabel = styled.div`
    width: 25%;
    text-align: start;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-transform:uppercase;
    color:${colors.blue};
    font-size: 13px;
`
const MediaInputBox = styled.div`
    width: 30%;
    display:flex;
    align-items:center
`
const MediaInputBoxLabel =styled.div`
    font-size: 13px;
    font-weight: initial;
    text-transform: none;
    margin-right:0.5rem;
`
const MediaButtons = styled.div`
    width:10%;
    display:flex
`
const Schedule = styled.div`
    width:10%;
    color:${colors.blue};
    font-size: 13px;
`

const InputStyle = {
    'border':`1px solid ${colors.greylight}`,
    'background':'transparent',
    'borderRadius': 'unset',
    'width': '100%',
    'fontSize': '13px',
    'fontWeight': 'initial',
    'height': '30px'
}
const MediaButtonStyle = {
    'width': '30px',
    'height': '30px',
    'fontSize':'15px',
    'padding':'0px'
}


const MediaButtonsIconWrapper = styled(FontAwesomeIcon)`
    color: ${colors.white};
`
const RemoveIcon = (props) => <MediaButtonsIconWrapper {...props} icon="trash-alt" />
const CalendarIcon = (props) => <MediaButtonsIconWrapper {...props} icon="calendar-alt" />

export {  
    CloseButton,
    MediaFormGroup,
    FlexBox,
    ContainerBox,
    MediaLabel,
    MediaInputBox,
    MediaInputBoxLabel,
    InputStyle,
    MediaButtons,
    RemoveIcon,
    CalendarIcon,
    MediaButtonStyle,
    Schedule
}
